window.AlertEngine = {
	
	init: function() {
		$(document).ready(function() {
			// Recupere les taches au format JSON
//			MyFacture.post( 'alert', {'action':"alertJson"}, function(data){
//				var tasks = data.tasks;
//				for(var i=0 ; i<tasks.length ; i++ ) {
//					tasks[i].allDay = (tasks[i].allDay == 'Y') ? true : false;
//					if(tasks[i].editable == 'N') {
//						tasks[i].editable = false;
//						tasks[i].disableResizing = true;
//					}
//					if(tasks[i].type == 'task') {
//						tasks[i].disableResizing = true;
//					}
//				}
				
				var calendar = $('#calendar').fullCalendar({

					/* General display */
					firstDay: 1,
					header: {
						left: 'month, agendaWeek, agendaDay',
						center: 'title',
						right: 'prev,next today'
					},

					/* Text/Time Customization */
					allDayText: Loc.g('Toute la journée'),
					axisFormat: Loc.g('HH:mm'),
					buttonText: {
						today: Loc.g("Aujourd'hui"),
						month: Loc.g('Mois'),
						week:  Loc.g('Semaine'),
						day:   Loc.g('Jour')
					},
					monthNames: [Loc.g('Janvier'), Loc.g('Février'), Loc.g('Mars'), Loc.g('Avril'), Loc.g('Mai'), Loc.g('Juin'), Loc.g('Juillet'), Loc.g('Août'), Loc.g('Septembre'), Loc.g('Octobre'), Loc.g('Novembre'), Loc.g('Décembre')],
					monthNamesShort: [Loc.g('Jan'), Loc.g('Fev'), Loc.g('Mar'), Loc.g('Avr'), Loc.g('Mai'), Loc.g('Jui'), Loc.g('Juil'), Loc.g('Au'), Loc.g('Sep'), Loc.g('Oct'), Loc.g('Nov'), Loc.g('Dec')],
					dayNames: [Loc.g('Dimanche'), Loc.g('Lundi'), Loc.g('Mardi'), Loc.g('Mercredi'), Loc.g('Jeudi'), Loc.g('Vendredi'), Loc.g('Samedi')],
					dayNamesShort: [Loc.g('Dim'), Loc.g('Lun'), Loc.g('Mar'), Loc.g('Mer'), Loc.g('Jeu'), Loc.g('Ven'), Loc.g('Sam')],
					timeFormat: {	// Determines the time-text that will be displayed on each event
						agenda: '',	// for agendaWeek and agendaDay do not display time in title (time already displayed in the view)
						'': 'H:mm'	// for all other views (19p)
					},
					columnFormat: {	// Determines the text that will be displayed on the calendar's column headings
						month: 'dddd',		// Monday
						week: Loc.g('ddd d/M'),	// Mon 7/9
						day: 'dddd'			// Monday
					},
					titleFormat: {	// Determines the text that will be displayed in the header's title
						week: Loc.g(" [MMM] d { '&#8212;' d[yyyy] MMMM yyyy}"),	// 7 - 13 Septembre 2009
						day: Loc.g('dddd d MMMM yyyy')								// Vendredi 20 Juillet 2012
					},
					
					/* Event Dragging & Resizing */
					editable: true,
					eventDrop: function( event, dayDelta, minuteDelta, allDay, revertFunc, jsEvent, ui, view ) { 
						var end = new Date(event.start);
						end.setHours(end.getHours()+1);
						AlertEngine.dropOrResize(event.id, event.start, end, allDay);
				
					},
					eventResize: function(event, dayDelta, minuteDelta, revertFunc, jsEvent, ui, view) {
						AlertEngine.dropOrResize(event.id, event.start, event.end, event.allDay);
					},

					/* Selection */
					selectable: true,
					selectHelper: true,
					select: function(start, end, allDay) {
						AlertEngine.createForm(true, start, end, allDay, calendar);
					},
					
					/* Clicking & Hovering */
					eventClick: function(calEvent, jsEvent, view) {
						calEvent.editable != false ? AlertEngine.editForm(calEvent.id) : AlertEngine.show(calEvent.id);
					},
					/* Evenements invokit */
					events: {url:'./?_f=alert&action=alertJson'}
					/* Evenements google calendar public */
//					eventSources: data.gcalPublic
				})
//			}, "json");
//			
//			
//			$("#add_gcal_public").click(function () {
//				$('#calendar').fullCalendar('rerenderEvents');
//			});
			
		});
	},
	
	// affiche les informations d'une alerte en lecture dans une popup (pas possible de modif l'alerte)
	show: function(id) {
		var options = {
			title	:  Loc.g("Alerte"),
			buttons	: [
				{
					text : Loc.g("Fermer"),
					click : function(){$(this).dialog("close");}
				}
			]
		};
		MyWindow.load("alertEngine", {action:"show", id:id}, options);
	},
	
	// drop ou resize une alerte existante
	dropOrResize: function(id, start, end, allDay) {
		MyFacture.post( 'alertEngine', {'action':"dropOrResize", "id": id, "start":start.toString(), "end":end.toString(), "allDay":allDay}, function(data){}, "json");
	},
	
	// creation d'une alerte depuis le dashboard (mettre dateto et datefrom à la date d'aujourd'hui)
	createNewFromDashboard: function(doctype, docid, dashboard) {
		var today = new Date();
		AlertEngine.createForm(false, today, today, true, false, doctype, docid, dashboard);
	},
	
	// creation d'une alerte
	createForm: function(isPopup, start, end, allDay, calendar, doctype, docid, dashboard){
		dashboard = undefined==dashboard ? "N" : dashboard;
		var optionsPopup = {
			title	:  Loc.g("Nouvelle alerte"),
			buttons	: [
					{
						text : Loc.g("Enregistrer"),
						click : function(){AlertEngine.add()}
					},{
						text : Loc.g("Annuler"), 
						click : function(){$(this).dialog("close")}
					}
				],
			callback : function(){AlertEngine.popup(isPopup, false, calendar, doctype, docid, dashboard);}
		};
		
		MyWindow.load("alertEngine", {action:"newForm", _data:'1', allDay:allDay, start:start.toGMTString(), end:end.toGMTString()}, optionsPopup);
	},
	
	// modification d'une alerte
	editForm: function(id, dashboard) {
		dashboard = undefined==dashboard ? "N" : dashboard;
		var optionsPopup = {
			title	:  Loc.g("Modification alerte"),
			buttons	: [
				{
					text : Loc.g("Enregistrer"), click : function(){AlertEngine.add()}
				},
				{
					text : Loc.g("Supprimer l'alerte"), click : function(){AlertEngine.deleteAlert(id, dashboard);$(this).dialog("close");}
				},
				{
					text : Loc.g("Annuler"), click : function(){$(this).dialog("close")}
				}
			],
			callback : function(){AlertEngine.popup(true, id, '','','',dashboard);}
		};
		MyWindow.load("alertEngine", {action:"editForm", id:id}, optionsPopup);
	},
	
	// popup de creation ou modif d'une alerte
	popup: function(isPopup, id, calendar, doctype, docid, dashboard){
		dashboard = undefined==dashboard ? "N" : dashboard;
		var action = "alertEngine&action=add&_data=1&dashboard="+dashboard;
		if(id) {
			action += "&id="+id;
		}
		
		var options = {
			success: function(data){
				AlertEngine.recordCallback(data, isPopup, calendar, dashboard);
			}, 
			dataType:"json"
		};
		MyForm.prepare("alertForm", action, options, isPopup);
		MyFacture.initEvent();
		
		$('#alert_linked').val(window.location);
		$('#alert_doctype').val(doctype);
		$('#alert_docid').val(docid);
		
		// switch evenement /tache
		$('.alert-type input').click(function(){
			var val = $(this).val();
			if (val=='task'){
				$('.alert-start-time').hide('fast');
				$('.alert-end-time').find('td:first').html('Date :');
			} else {
				$('.alert-start-time').show('fast');
				$('.alert-end-time').find('td:first').html('Date de fin :');
			}
		});
		
		// Alertes
		$("#alert_sendEmail").click(function () {
			$('#rappelTemplate li').clone().appendTo($('#listRappel'));
			MyFacture.customForm($('#listRappel'));
			
			if($('#contactEmail').is((':hidden'))) {
				$('#contactEmail').show();
			}
			
			if($('#rappels').is((':hidden'))) {
				$('#rappels').show();
			}
		});
		
		// Click toutes la journée => cache les champs heures
		$('#alert_allDay').click(function() {
			if($('#alert_allDay').is(':checked')) {
				$('.hourPicker').hide();
			}
			else {
				$('.hourPicker').show();
				MyFacture.customForm($('.hourPicker'));
			}
		});
		
		// Suppression rappels
		$('.deleteRappel').live("click", function() {
			$(this).parent().remove();
			if($('#listRappel li').length == 0) {
				$('#rappels').hide();
			}
		});
	},
	
	// creation ou modification d'une alerte
	add: function(){
		var formId = "alertForm";
		$("#"+formId).submit();
	},
	
	recordCallback: function(data,isPopup, calendar, dashboard){
		dashboard = undefined==dashboard ? "N" : dashboard;
		
		var formIsOk = MyForm.processJson(data, "alertForm");
		if(formIsOk) {
			
			if (dashboard == "Y"){
				var new_item = $(data.taskhtml).hide();
				
				if (data.refresh == "Y"){
					var currentTask = $('#task_'+data.task.id);
					currentTask.before(new_item);
					currentTask.remove();
				} else {
					$('.'+data.tasktype+'container').append(new_item);
				}
				MyWindow.close();
				if ($('.'+data.tasktype+'container').prev().hasClass('hidden')){
					$('.'+data.tasktype+'container').prev().removeClass('hidden')
				}
				if (data.tasktype != ""){
					new_item.slideDown('normal');
				} else {
					
				}
				$('.agenda-container').find('.noEvent').hide();
				EventsEngine.refreshContainer();
			} else {
				Utils.reload();
			}
		}
		return true;
		
	},

    cancelSend: function(id){
        MyFacture.post( 'alertEngine', {'action':"cancelSend", "id": id}, function(data){}, "json");
    },
	
	
	completeAlert: function(id){
		var msg =  Loc.g("Si vous complétez cette tâche elle disparaitra de votre liste. Vous pourrez la retrouver dans l'agenda complet en cliquant sur <b>voir tout l'agenda</b>. <br/><br/>Voulez vous continuer ?");
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Compléter la tâche"),
			buttons		: [
				{text : Loc.g("Non"), click : function(){$(this).dialog("close");}},
				{text : Loc.g("Oui"), click : function(){AlertEngine.confirmCompleteAlert(id);$(this).dialog("close");}}
			]
		};

		MyWindow.alert(msg, options);
		
	},
	
	confirmCompleteAlert: function(id){
		MyFacture.post( 'alertEngine', {'action':"complete", "id": id}, function(data){
			$('#task_' + data.taskId).slideUp('normal', function(){$(this).remove()});
			EventsEngine.refreshContainer();
		}, "json");
	},
	
	deleteAlert: function(id, dashboard) {
		var msg =  Loc.g("Vous allez supprimer cette alerte. Attention, une fois supprimée vous ne pourrez plus la récupérer.<br/><br/>Voulez vous continuer ?");
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression de l'alerte"),
			buttons		: [
				{text : Loc.g("Non"), click : function(){$(this).dialog("close");}},
				{text : Loc.g("Oui"), click : function(){AlertEngine.confirmDeleteAlert(id, dashboard);$(this).dialog("close");}}
			]
		};

		MyWindow.alert(msg, options);

	},
	
	confirmDeleteAlert: function(id, dashboard){
		MyFacture.post( 'alertEngine', {'action':"delete", "id": id}, function(data){
			$('#task_' + data.taskId).slideUp('normal', function(){$(this).remove()});
			if(dashboard == 'N'){
				Utils.reload();
			} else {
				EventsEngine.refreshContainer();
			}
		}, "json");
	},
	
	addPublicGcalForm: function() {
		var options = {
			title	:  Loc.g("Ajouter un google agenda public"),
			buttons	: [
				{text : Loc.g("Enregistrer"), click : function(){AlertEngine.addPublicGcal()}},
				{text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}}
			],
			callback	: function(){AlertEngine.addPublicGcalPopup();}
		};
		MyWindow.load("alertEngine", {action:"gcalPublicForm"}, options);
	},
	
	addPublicGcalPopup: function() {
		var options = {
			success: function(data){
				AlertEngine.addPublicGcalCallback(data);
			}, 
			dataType:"json"
		};
		MyForm.prepare("gcalPublicFormulaire", "alertEngine&action=addGcalPublic", options, true);
		MyFacture.initEvent();
	},
	
	addPublicGcal: function() {
		$("#gcalPublicFormulaire").submit();
	},
	
	addPublicGcalCallback: function(data) {
		var formIsOk = MyForm.processJson(data, "gcalPublicFormulaire");
		if(formIsOk) {
			MyWindow.close();
			var gcalPublicHTML = $('#templateGcalPublic').html();
			gcalPublicHTML = Text.replace(gcalPublicHTML, "ID", data.gcalpublic.id);
			$('#gcalPublicList').append(gcalPublicHTML);
			$('#gcal_' + data.gcalpublic.id + ' #gcal_public_label').html(data.gcalpublic.name);
			$('#gcal_' + data.gcalpublic.id + ' input:hidden').val(data.gcalpublic.url);
			
			
			MyFacture.customForm($('#gcal_' + data.gcalpublic.id));
		}
	},
	
	displayGcalPublic: function(id) {
		var url = $('input:hidden[name=gcal_public_url_' + id + ']').val();
		
		//ajoute le calendier (affichage)
		if($('#gcal_public_' + id).is(':checked')) {
			$('#calendar').fullCalendar( 'addEventSource', url );
			MyFacture.post( 'alertEngine', {'action':"displayGcalPublic", "id": id}, function(data){}, "json");
		}
		//supprime le calendrier (affichage)
		else {
			$('#calendar').fullCalendar( 'removeEventSource', url );
			MyFacture.post( 'alertEngine', {'action':"cancelDisplayGcalPublic", "id": id}, function(data){}, "json");
		}

//		urls = ["https://www.google.com/calendar/feeds/urm2ac49mm8rijspltk7sl47huh3us5l%40import.calendar.google.com/public/basic", "https://www.google.com/calendar/feeds/he1aravacmsf6bfsv1sva7shr51e8388%40import.calendar.google.com/public/basic"];
//		for(var i=0 ; i<urls.length ; i++) {
//			$('#calendar').fullCalendar( 'addEventSource', urls[i] );
//		}
	},
	
	deleteGcalPublic: function(id) {
		MyFacture.post( 'alertEngine', {'action':"deleteGcalPublic", "id": id}, function(data){
			$('#gcal_' + data.id).remove();
		}, "json");
	}
	
	
};
